import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import i18n from '@/settings/i18n';
import styled from 'styled-components';

import * as constants from '@/constants';
import { SubscriptionDetail } from '@/types/subscriptions/subscription';
import { pages, formatRoute } from '@/settings/pages';

type Props = {
  subscription: SubscriptionDetail;
};

export const DoneContent: React.FC<Props> = ({ subscription }) => {
  const { t } = useTranslation();
  return (
    <>
      <StyledDetail>
        <div className="subsctiption-code-link">
          <div>
            <p>{t('models.subscription.requestCode')}:</p>
            <span
              className="subsctiption-code-link-id"
              data-test="subscription-request-code"
            >
              {subscription.requestCode}
            </span>
          </div>
          <Link
            data-test="subsctiption-code-done-link"
            className="subsctiption-code-link-a"
            to={formatRoute(pages.subscription.detail, {
              requestCode: subscription.requestCode,
            })}
          >
            <div className="subsctiption-code-link-label">
              {t('text.subscription.codeLink')}
            </div>
          </Link>
        </div>
      </StyledDetail>
      {i18n.languages[0] === 'ja' ? (
        <>
          <p style={{ color: '#dd3a38' }}>
            <Trans i18nKey="text.subscription.done.management">
              <br />
              <a
                href={t('pages.support.hodaiAdmin.url')}
                rel="noopener noreferrer"
                target="_blank"
              >
                link
              </a>
            </Trans>
          </p>
          <p>{t('text.subscription.done.sentMail')}</p>
          <p>
            <Trans i18nKey="text.subscription.done.destination">
              <br />
              <br />
              <br />
            </Trans>
          </p>
          <p>
            <Trans
              i18nKey="text.subscription.done.changeOrCancel"
              values={{ num: constants.INTERVAL_BUSINESS_DAYS + 1 }}
            >
              <br />
              <br />
              <br />
              <br />
              <br />
            </Trans>
          </p>
          <p>{t('text.subscription.done.inquiry')}</p>
        </>
      ) : (
        <>
          <Trans i18nKey="text.subscription.done.sentMail"></Trans>
          <p>
            <Trans i18nKey="text.subscription.done.destination">
              <br />
              <br />
              <br />
            </Trans>
          </p>
          <p>
            <Trans
              i18nKey="text.subscription.done.changeOrCancelAboutHodaiAndUnlimited"
              values={{ num: constants.INTERVAL_BUSINESS_DAYS + 1 }}
            >
              <br />
              <br />
              <a
                href={t('pages.support.hodaiAdmin.url')}
                rel="noopener noreferrer"
                target="_blank"
              >
                link
              </a>
              <br />
            </Trans>
          </p>
          <p>
            <Trans i18nKey="text.subscription.done.changeOrCancelAboutEmba2AndHodaiPlus">
              <br />
              <br />
            </Trans>
          </p>
          <p>{t('text.subscription.done.inquiry')}</p>
        </>
      )}
    </>
  );
};

const StyledDetail = styled.div`
  .subsctiption-code-link {
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 2em 0 !important;
    padding: 21px;
    background-color: white;
    box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15);
    border-radius: 4px;
    border: 1px solid rgba(34, 36, 38, 0.15);
  }

  .subsctiption-code-link-id {
    font-size: 21px;
  }

  .subsctiption-code-link-a {
    font-size: 14px;
    display: block;
  }

  .subsctiption-code-link-label:hover {
    opacity: 0.8;
  }

  .subsctiption-code-link-label {
    padding: 0.75em 1em !important;
    font-size: 1em !important;
    color: rgba(0, 0, 0, 0.6);
    font-weight: 700;
    background-color: #e8e8e8;
    border-radius: 4px;
    line-height: 1;
  }
`;
